import dayjs from '@skynet/formatting-date';

// If the start of the week is today, set the comparison start to the start of the previous week
export const initialStartDate = dayjs().startOf('isoWeek').isSameOrAfter(dayjs(), 'date')
  ? dayjs().startOf('isoWeek').add(-1, 'week').format('YYYY-MM-DD HH:mm')
  : dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
export const initialEndDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm');
